var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 21,
    viewBox: "0 0 133 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0.734619L12.7451 7.64445H20.0106L14.1327 11.915L16.3779 18.8248L10.5 14.5543L4.62215 18.8248L6.86729 11.915L0.989435 7.64445H8.25486L10.5 0.734619Z",
    fill: "#FFBC5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 0.734619L40.7451 7.64445H48.0106L42.1327 11.915L44.3779 18.8248L38.5 14.5543L32.6221 18.8248L34.8673 11.915L28.9894 7.64445H36.2549L38.5 0.734619Z",
    fill: "#FFBC5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 0.734619L68.7451 7.64445H76.0106L70.1327 11.915L72.3779 18.8248L66.5 14.5543L60.6221 18.8248L62.8673 11.915L56.9894 7.64445H64.2549L66.5 0.734619Z",
    fill: "#FFBC5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 0.734619L96.7451 7.64445H104.011L98.1327 11.915L100.378 18.8248L94.5 14.5543L88.6221 18.8248L90.8673 11.915L84.9894 7.64445H92.2549L94.5 0.734619Z",
    fill: "#FFBC5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 0.734619L124.745 7.64445H132.011L126.133 11.915L128.378 18.8248L122.5 14.5543L116.622 18.8248L118.867 11.915L112.989 7.64445H120.255L122.5 0.734619Z",
    fill: "#FFBC5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.182443ac2a115023a15ea8584e8ffa53.svg";
export { ForwardRef as ReactComponent };